import styled from 'styled-components';
import { CSVLink } from 'react-csv';

export default styled(CSVLink)`
    color: inherit;
`;
